export const AI_WEIGHT_ANALYZER_URL = 'https://weightmanager.petsdeli.de/';

export const AI_WEIGHT_ENABLED = false;

export const AI_WEIGHT_ENTRY_POINTS = {
  homeDog: 'home_dog',
  homeCat: 'home_cat',
  cdpTile: 'cdp_tile',
  petProfile: 'pet_profile',
  overlay: 'overlay',
} as const;

export type AiWeightEntryPointId =
  (typeof AI_WEIGHT_ENTRY_POINTS)[keyof typeof AI_WEIGHT_ENTRY_POINTS];

export const AI_WEIGHT_POSTMESSAGE_TYPES = {
  emailSubmitted: 'pd_ai_weight:email_submitted',
  backToShopClick: 'pd_ai_weight:back_to_shop_click',
} as const;
